import type { Web3Library } from '../wallet/walletContext'

import { findRecentRouterTransactionHash } from '../wallet/findRecentRouterTransactionHash'

/** @deprecated Usar `findRecentRouterTransactionHash` en domain/wallet. */
export async function findRecentSwapTransactionHash(
  library: Web3Library,
  account: string,
  notBeforeMs: number,
  maxBlocks?: number,
  options?: { excludeHashes?: string[] },
): Promise<string | null> {
  return findRecentRouterTransactionHash(library, account, notBeforeMs, maxBlocks, options)
}
